import * as React from "react";
import { forwardRef } from "react";
const SvgArrowNarrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M3.33333 10H16.6667M11.6667 15L16.6667 10L11.6667 5", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgArrowNarrowRight);
export { ForwardRef as ReactComponent };
